
export const TAX=0.03
export const GOLD='#efb810'
